import { apiUrl } from "../../../Constant/apiConstant"
import { getRequest, postJsonRequest } from "../../../service/apiService"

export const getPreboardingSummaryList= async(tenant: undefined | string)=>{
    try{
        const response = await getRequest(apiUrl.JM_GET_PREBOARDING_SUMMARY,{}, tenant,true)

        if(response.status === 200){
            const {Data,Status} = response.data
            return Status ? Data : []
        }
    }catch(error){
        console.log(error)
    }
    return []
}


export const getPreboardingCandidates = async (tenant: undefined | string,payLoad:any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_PREBOARDING_CANDIDATES, payLoad, tenant, true);
        if (response.status === 200) {
            const { Data, Status,Total } = response.data;
            return Status ? { Data, Total } : { Data: [], Total: 0 };
        }
    } catch (error) {
        console.log(error);
    }
    return null
}

export const sendPreboardingNotification = async (tenant: undefined | string, payload: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_SEND_PREBOARDING_NOTIFICATION, payload, tenant, true);
        if (response.status === 200) {
            const { Status } = response.data;
            return Status;
        }
    } catch (error) {
        console.log(error);
    }
    return false;
}

export const getBGVPendingCandidates = async (tenant: undefined | string) => {
    try {
        const response = await getRequest(apiUrl.JM_GET_BGV_PENDING_CANDIDATES, {}, tenant, true);
        if (response.status === 200) {
            const { Data, Status } = response.data;
            return Status ? Data : [];
        }
    } catch (error) {
        console.log(error);
    }
    return [];
}

export const notifyInternalTeams = async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response = await postJsonRequest(apiUrl.JM_POST_NOTIFY_INTERNAL_TEAMS,payLoad,tenant,true)
        if(response.status === 200){
            const {Status,Message} = response.data

            return {Status,Message}
        }
    }catch(error){
        console.log(error)
    }
    return null
}